import React from "react";
import { Box, Container } from "@mui/material";
import MobileSkillAchievements from "./MobileSkillAchievements";
import MobileRankings from "./MobileRankings";
import MobileCourses from "./MobileCourses";



const MobileSkillboard: React.FC = () => {
  return (
    <Container 
      maxWidth={false} 
      disableGutters
      sx={{ 
        minHeight: '100vh',
        marginTop: '4rem',
        backgroundColor: '#f5f5f5',
        pt: 8, // Account for mobile header
        pb: 2
      }}
    >
      <Box sx={{pb: 2 }}>
        {/* Mobile optimized sections */}
        <MobileSkillAchievements />
        <MobileRankings />
        <MobileCourses />
      </Box>
    </Container>
  );
};

export default MobileSkillboard;